import {FormModel} from '../forms/form-model';
import {InputModel} from '../forms/input-model';

export class ProjectFormUtil {

    public static generateProjectForm():FormModel {

        const inputName = new InputModel();
        inputName.type = 'text';
        inputName.label.set('en','Name');
        inputName.validation.set('required','true');
        inputName.placeholder.set('en','Project Name');
        inputName.name.set('en','ProjectName');

        const inputClient = new InputModel();
        inputClient.type = 'dropdown';
        inputClient.label.set('en','Client');
        inputClient.validation.set('required','true');
        inputClient.placeholder.set('en','Client');
        inputClient.name.set('en','ProjectClient');

        const inputCode = new InputModel();
        inputCode.type = 'text';
        inputCode.label.set('en','Code');
        inputCode.validation.set('required','true');
        inputCode.placeholder.set('en','Project Code');
        inputCode.name.set('en','ProjectCode');

        /*const webProject = new InputModel();
        inputCode.type = 'checkbox';
        inputCode.label.set('en','Web Project');
        inputCode.validation.set('required','false');
        inputCode.name.set('en','WebProject');*/

        const form = new FormModel();
        form.title = 'New Project';
        form.inputs.push(inputName);
        form.inputs.push(inputClient);
        form.inputs.push(inputCode);

        return form;
    }

}
